export function romanToNumber(roman: string): number {
  const values: Record<string, number> = { i: 1, v: 5, x: 10, l: 50, c: 100, d: 500, m: 1000 }
  let result = 0
  const chars = roman.toLowerCase().split('')
  for (let i = 0; i < chars.length; i++) {
    const char = chars[i]
    const nextChar = chars[i + 1]
    const current = char ? values[char] || 0 : 0
    const next = nextChar ? values[nextChar] || 0 : 0
    result += current < next ? -current : current
  }
  return result
}

export function numberToRoman(num: number): string {
  const pairs: [number, string][] = [
    [1000, 'm'],
    [900, 'cm'],
    [500, 'd'],
    [400, 'cd'],
    [100, 'c'],
    [90, 'xc'],
    [50, 'l'],
    [40, 'xl'],
    [10, 'x'],
    [9, 'ix'],
    [5, 'v'],
    [4, 'iv'],
    [1, 'i'],
  ]
  let result = ''
  for (const [value, numeral] of pairs) {
    while (num >= value) {
      result += numeral
      num -= value
    }
  }
  return result
}
